<template>
  <div class="page flex">
    <div class="todo-menus" v-if="countInfo.all > 0">
      <a-affix :target="affixTarget">
        <a-card :bordered="false" :body-style="{ padding: '16px 16px' }" style="border-radius: 10px">
          <div class="todo-menu-list">
            <div class="todo-menu" :class="{ active: type == -1 }" @click="type = -1">
              <span class="col">所有任务</span>
              <span class="v-mr-auto">
                <a-tag :color="countInfo.all ? '#eb2f96' : '#999'" class="tag-tiny">{{ countInfo.all.toFixed(0) }}</a-tag>
              </span>
            </div>
            <a-divider></a-divider>
            <template v-if="userinfo.busiRoles && userinfo.busiRoles.some(role => ['U01', 'U02', 'U03', 'U04'].includes(role))">
              <div class="todo-menu v-mb-sm" :class="{ active: type == 1 }" @click="type = 1" v-if="countInfo.type1 > 0">
                <span class="col">项目申请</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type1 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type1.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 2 }" @click="type = 2" v-if="countInfo.type2 > 0">
                <span class="col">筹款申请</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type2 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type2.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 4 }" @click="type = 4" v-if="countInfo.type4 > 0">
                <span class="col">项目预算</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type4 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type4.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 5 }" @click="type = 5" v-if="countInfo.type5 > 0">
                <span class="col">项目计划</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type5 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type5.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 6 }" @click="type = 6" v-if="countInfo.type6 > 0">
                <span class="col">财务请款</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type6 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type6.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 7 }" @click="type = 7" v-if="countInfo.type7 > 0">
                <span class="col">财务进展</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type7 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type7.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 8 }" @click="type = 8" v-if="countInfo.type8 > 0">
                <span class="col">项目报告</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type8 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type8.toFixed(0) }}</a-tag>
                </span>
              </div>
              <div class="todo-menu v-mb-sm" :class="{ active: type == 9 }" @click="type = 9" v-if="countInfo.type9 > 0">
                <span class="col">项目变更</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type9 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type9.toFixed(0) }}</a-tag>
                </span>
              </div>
            </template>
            <template v-if="userinfo.busiRoles && userinfo.busiRoles.some(role => ['U05', 'U06'].includes(role))">
              <div class="todo-menu v-mb-sm" :class="{ active: type == 10 }" @click="type = 10" v-if="countInfo.type10 > 0">
                <span class="col">会议表决</span>
                <span class="v-mr-auto">
                  <a-tag :color="countInfo.type10 ? '#f24a78' : '#999'" class="tag-tiny">{{ countInfo.type10.toFixed(0) }}</a-tag>
                </span>
              </div>
            </template>
          </div>
        </a-card>
      </a-affix>
    </div>
    <div class="todo-tasks col v-px-md relative-position">
      <div class="v-mt-md" style="position: absolute; top: 150px; left: 50%;transform: translateX(-50%)">
        <a-spin tip="加载中..." :spinning="loading"> </a-spin>
      </div>
      <div class="v-mt-md" style="border: 1px solid #eee; padding: 150px 0" v-if="taskList.length == 0">
        <a-empty :image="emptyImage" v-if="!loading">
          <div slot="description">暂无任务</div>
        </a-empty>
      </div>
      <div class="todo-list" v-if="taskList.length">
        <div class="todo-list-item" v-for="(task, index) in taskList" :key="index">
          <div class="todo-item-header flex items-center">
            <h4 class="hover-line" v-if="task.taskType == 10">{{ task.meetingTitle }}</h4><template v-if="task.taskType == 10"></template>
            <h4 class="hover-line" v-else>{{ task.projectName }}</h4>
            <a-tag class="v-ml-auto" color="#3f51b5" v-if="task.taskType == 10">会议</a-tag>
            <template v-else>
              <a-tag class="v-ml-auto" color="#3f51b5" v-if="task.projectCate == 1">合作项目</a-tag>
              <a-tag class="v-ml-auto" color="#3f51b5" v-else-if="task.projectType == 21">螺蛳壳改造</a-tag>
              <a-tag class="v-ml-auto" color="#3f51b5" v-else-if="task.projectType == 22">精灵书屋</a-tag>
            </template>
          </div>
          <div title="点击去处理" class="todo-item flex items-center" @click="handleTask(task)">
            <div v-if="task.taskType == 1"><a-icon type="alert" class="v-mr-sm" />提交项目申请<span class="text-red" v-if="task.taskCheckResult == 0">（被驳回）</span></div>
            <div v-else-if="task.taskType == 2"><a-icon type="alert" class="v-mr-sm" />提交筹款申请</div>
            <div v-else-if="task.taskType == 3"><a-icon type="alert" class="v-mr-sm" />提交筹款申请<span class="text-red">（被驳回）</span></div>
            <div v-else-if="task.taskType == 4"><a-icon type="alert" class="v-mr-sm" />提交项目预算<span class="text-red" v-if="task.taskCheckResult == -1">（被驳回）</span></div>
            <div v-else-if="task.taskType == 5"><a-icon type="alert" class="v-mr-sm" />制订项目计划<span class="text-red" v-if="task.taskCheckResult == -1">（被驳回）</span></div>
            <div v-else-if="task.taskType == 6"><a-icon type="alert" class="v-mr-sm" />有一笔{{ $utils.thousands(task.itemAmount) }}元的财务请款待提交<span class="text-red" v-if="task.itemState == -1">（被驳回）</span></div>
            <div v-else-if="task.taskType == 7"><a-icon type="alert" class="v-mr-sm" />有一笔{{ $utils.thousands(task.itemAmount) }}元的财务报销待提交<span class="text-red" v-if="task.itemState == -1">（被驳回）</span></div>
            <div v-else-if="task.taskType == 8"><a-icon type="alert" class="v-mr-sm" /> 项目报告：{{ task.reportName }}待提交<span class="text-red" v-if="task.itemState == -1">（被驳回）</span></div>
            <div v-else-if="task.taskType == 9">
              <a-icon type="alert" class="v-mr-sm" /><template v-if="task.itemType == 1">项目周期变更申请待提交</template><template v-else-if="task.itemType == 2">项目预算变更申请待提交</template><template v-else-if="task.itemType == 3">项目计划变更申请待提交</template
              ><span class="text-red" v-if="task.itemState == -1">（被驳回）</span>
            </div>
            <div v-else-if="task.taskType == 10">投票主题【{{ task.voteTitle }}】待投票 </div>
            <div class="todo-item-icon v-ml-auto">
              <a-icon type="arrow-right" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import { listMyTasks } from '@/api/user'
export default {
  data() {
    return {
      type: -1,
      taskList: [],
      tasks: [],
      countInfo: {
        all: 0,
        type1: 0,
        type2: 0,
        type3: 0,
        type4: 0,
        type5: 0,
        type6: 0,
        type7: 0,
        type8: 0,
        type9: 0,
        type10: 0,
      },
    }
  },
  watch: {
    type() {
      this.load()
    },
  },
  methods: {
    load() {
      this.loading = true
      listMyTasks().then(({ data }) => {
        if (data.success) {
          let result = data.result
          gsap.to(this.countInfo, 0.5, {
            all: result.length,
            type1: result.filter(d => d.taskType == 1).length,
            type2: result.filter(d => d.taskType == 2 || d.taskType == 3).length,
            // type3: result.filter(d => d.taskType == 3).length,
            type4: result.filter(d => d.taskType == 4).length,
            type5: result.filter(d => d.taskType == 5).length,
            type6: result.filter(d => d.taskType == 6).length,
            type7: result.filter(d => d.taskType == 7).length,
            type8: result.filter(d => d.taskType == 8).length,
            type9: result.filter(d => d.taskType == 9).length,
            type10: result.filter(d => d.taskType == 10).length,
          })
          this.taskList = this.type == -1 ? result : this.type == 2 ? result.filter(d => d.taskType == 2 || d.taskType == 3) : result.filter(d => d.taskType == this.type)
        }
        this.loading = false
      })
    },
    handleTask(task) {
      let { projectId, taskType, projectCate, projectType, itemId, meetingId } = task
      if (taskType == 1) {
        this.$router.push(`project/funded/draft?id=${projectId}`)
      } else if (taskType == 2 || taskType == 3) {
        this.$router.push(`project/funded/view/raise?id=${projectId}`)
      } else if (taskType == 6) {
        if (projectCate == 1) {
          this.$router.push(`project/funded/applyBill/draft?id=${projectId}&aid=${itemId}`)
        } else if (projectType == 21) {
          this.$router.push(`project/house/applyBill/draft?id=${projectId}&aid=${itemId}`)
        }
      } else if (taskType == 4) {
        if (projectType == 21) {
          this.$router.push(`project/house/budget?id=${projectId}`)
        }
      } else if (taskType == 5) {
        if (projectCate == 1) {
          this.$router.push(`project/funded/makeplan?id=${projectId}`)
        } else if (projectType == 21) {
          this.$router.push(`project/house/plan/draft?id=${projectId}`)
        }
      } else if (taskType == 7) {
        if (projectCate == 1) {
          this.$router.push(`project/funded/progress/draft?id=${projectId}&bid=${itemId}`)
        } else if (projectType == 21) {
          this.$router.push(`project/house/progress/draft?id=${projectId}&bid=${itemId}`)
        }
      } else if (taskType == 8) {
        if (projectCate == 1) {
          this.$router.push(`project/funded/report/draft?id=${projectId}&rid=${itemId}`)
        } else if (projectType == 21) {
          this.$router.push(`project/house/report/draft?id=${projectId}&rid=${itemId}`)
        } else if (projectType == 22) {
          this.$router.push(`project/study/report/draft?id=${projectId}&rid=${itemId}`)
        }
      } else if (taskType == 9) {
        if (projectCate == 1) {
          this.$router.push(`project/funded/changeinfo/draft?id=${projectId}&cid=${itemId}`)
        } else if (projectType == 21) {
          this.$router.push(`project/house/changeinfo/draft?id=${projectId}&cid=${itemId}`)
        }
      } else if (taskType == 10) {
        this.$router.push(`meeting/vote?id=${meetingId}`)
      }
    },
  },
  created() {
    this.load()
  },
}
</script>
